import { PlasmError } from "./PlasmError";
export class PlasmInternalError extends PlasmError {
    constructor() {
        super(...arguments);
        this.name = "PlasmInternalError";
        this.isHandled = false;
    }
}
